import React, { useEffect, useState } from "react";
import { useModalManager } from "./ModalManager/ModalManager";
import "./DisclaimerModal.css";

const DisclaimerModal: React.FC = () => {
  const { currentModalId, acknowledgeModal } = useModalManager();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(currentModalId === 'disclaimer');
  }, [currentModalId]);

  const handleAcknowledge = () => {
    setOpen(false);
    acknowledgeModal('disclaimer');
  };

  if (!open) return null;

  return (
    <div className="disclaimer-modal-overlay">
      <div className="disclaimer-modal custom-disclaimer-modal">
        <h2 className="disclaimer-modal-title">Confidential Information Acknowledgment</h2>
        <hr className="disclaimer-modal-hr" />
        <div className="disclaimer-modal-info-box">
          <span className="disclaimer-modal-info-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#23292c"/><text x="12" y="17" textAnchor="middle" fontSize="13" fill="#fff" fontFamily="Arial" fontWeight="bold">i</text></svg>
          </span>
          <span className="disclaimer-modal-info-text">
            All information contained in the Motorola Solutions API Hub is the intellectual property of Motorola Solutions.<br />
            All information should be treated as confidential and must not be distributed or shared with third parties.
          </span>
        </div>
        <div className="disclaimer-modal-btn-row">
          <button
            className="disclaimer-modal-btn"
            onClick={handleAcknowledge}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;
